import { render, staticRenderFns } from "./WaybillCommentsTable.vue?vue&type=template&id=27e9f902&scoped=true&"
import script from "./WaybillCommentsTable.vue?vue&type=script&lang=js&"
export * from "./WaybillCommentsTable.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCommentsTable.vue?vue&type=style&index=0&id=27e9f902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e9f902",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QItemSection,QIcon,QItemLabel,QSeparator,QCardActions,QBtn,QTable,QTr,QTh,QTd,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QItemSection,QIcon,QItemLabel,QSeparator,QCardActions,QBtn,QTable,QTr,QTh,QTd}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
